import React from 'react';
import classNames from 'classnames';

const NbiLogo = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 850 680"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M538.6 336.1c-2.5.3-5.1-.3-7.3-2l-34.9-27.6c-4.2-3.3-4.9-9.4-1.6-13.6s9.4-4.9 13.6-1.6l34.9 27.6c4.2 3.3 4.9 9.4 1.6 13.6-1.6 2.1-3.9 3.3-6.3 3.6z"
        fill="#abc70c"
      />
      <path
        d="M462.6 170.5c-3.6 0-7.2-1.5-9.8-4.5l-68.5-79.2c-4.7-5.4-4.1-13.5 1.3-18.2s13.5-4.1 18.2 1.3l68.5 79.2c4.7 5.4 4.1 13.5-1.3 18.2-2.4 2.2-5.4 3.2-8.4 3.2z"
        fill="#51b05c"
      />
      <path
        d="M591.1 210.1c-2.7 0-5.5-.8-7.9-2.5-6.2-4.4-7.7-12.9-3.3-19.1l81.3-115.1c4.4-6.2 12.9-7.7 19.1-3.3s7.7 12.9 3.3 19.1l-81.3 115.1c-2.7 3.8-6.9 5.8-11.2 5.8z"
        fill="#00a584"
      />
      <path
        d="M615 270.7c-6.9 0-13-4.9-14.3-12-1.4-7.9 3.9-15.4 11.8-16.8l173-30.7c7.9-1.4 15.4 3.9 16.8 11.8s-3.9 15.4-11.8 16.8l-173 30.7c-.8.1-1.7.2-2.5.2z"
        fill="#009383"
      />
      <path
        d="M803.9 410.8c-1.6 0-3.2-.3-4.9-.8l-205-68.5c-8-2.7-12.4-11.4-9.7-19.4s11.4-12.4 19.4-9.7l205 68.5c8 2.7 12.4 11.4 9.7 19.4-2.1 6.5-8 10.5-14.5 10.5z"
        fill="#00837f"
      />
      <path
        d="M532.1 170.4c-6.7 0-12.6-5-13.6-11.8l-16.6-119c-1-7.5 4.2-14.4 11.7-15.5s14.4 4.2 15.5 11.7l16.6 118.9c1 7.5-4.2 14.4-11.7 15.5-.6.1-1.2.2-1.9.2z"
        fill="#1daa72"
      />
      <path
        d="M333 222c-5.9 0-11.1-4.3-12-10.3-1-6.6 3.6-12.8 10.2-13.7l92.4-13.6c6.6-1 12.8 3.6 13.7 10.2s-3.6 12.8-10.2 13.7l-92.4 13.6c-.5.1-1.1.1-1.7.1z"
        fill="#70b644"
      />
      <path
        d="M466.1 367.4c-5.4.3-10.2-3.7-10.9-9.2l-8.1-65.9c-.7-5.8 3.4-11 9.1-11.7s11 3.4 11.7 9.1l8.1 65.9c.7 5.8-3.4 11-9.1 11.7-.3 0-.6.1-.8.1z"
        fill="#9ac11b"
      />
      <path
        d="M694.3 587.9c-5.1 0-10.2-2.4-13.3-7L554.1 396.2c-5-7.3-3.2-17.4 4.2-22.4 7.3-5 17.4-3.2 22.4 4.2l126.9 184.7c5 7.3 3.2 17.4-4.2 22.4-2.8 1.9-5.9 2.8-9.1 2.8z"
        fill="#007379"
      />
      <path
        d="M494.9 650.7c-9.4 0-16.9-7.6-16.9-16.9V411.6c0-9.4 7.6-16.9 16.9-16.9 9.4 0 16.9 7.6 16.9 16.9v222.2c0 9.3-7.6 16.9-16.9 16.9zM400.3 516.3c13.1-12.9 21.2-30.8 21.2-50.5 0-39.2-31.9-71.1-71.1-71.1H282c-9.4 0-16.9 7.6-16.9 16.9v222.2c0 9.4 7.6 16.9 16.9 16.9h80.1c40.1 0 72.7-32.6 72.7-72.7-.1-26-13.8-48.9-34.5-61.7zm-99.4-90.2h48.3c21.9 0 39.6 17.8 39.6 39.6s-17.8 39.6-39.6 39.6h-48.3c-1.8 0-3.2-1.4-3.2-3.2v-72.9c0-1.6 1.4-3.1 3.2-3.1zm60 193.1h-60c-1.8 0-3.2-1.4-3.2-3.2v-76c0-1.8 1.4-3.2 3.2-3.2h60c22.7 0 41.2 18.5 41.2 41.2 0 22.8-18.5 41.2-41.2 41.2zM210.2 394.7c-9.4 0-16.9 7.6-16.9 16.9v167.6S74 405.5 71.6 402c-3.1-4.4-8.2-7.4-14-7.4-9.4 0-16.9 7.6-16.9 16.9v222.2c0 9.4 7.6 16.9 16.9 16.9s16.9-7.6 16.9-16.9V466.2s119.8 174.4 121.7 177.2c3.1 4.4 8.2 7.4 14 7.4 9.4 0 16.9-7.6 16.9-16.9V411.6c.1-9.4-7.5-16.9-16.9-16.9z"
        fill="#006770"
      />
      <path
        d="M376.9 331.7c-2.4 0-4.9-.8-6.9-2.4-4.9-3.8-5.8-10.9-2-15.9l53.4-68.7c3.8-4.9 10.9-5.8 15.9-2 4.9 3.8 5.8 10.9 2 15.9l-53.4 68.7c-2.3 2.9-5.6 4.4-9 4.4z"
        fill="#88bc24"
      />
      <path
        d="M523.9 274.3c-3.6.6-7.4-1.1-9.3-4.5-2.3-4.3-.7-9.7 3.6-12l19.2-10.4c4.3-2.3 9.7-.7 12 3.6s.7 9.7-3.6 12l-19.2 10.4c-.8.5-1.8.8-2.7.9z"
        fill="#bc0"
      />
      <circle cx="505.5" cy="234" r="9.7" fill="#cad100" />
    </svg>
  );
};

export type TopbarProps = {
  justify?: 'start' | 'center';
  className?: string;
  children?: React.ReactNode;
};

export const Topbar: React.FC<TopbarProps> = ({
  justify = 'start',
  className,
  children,
}) => {
  return (
    <header
      className={classNames(
        'flex items-center bg-white px-4 py-3 border-b-2 border-lime-500 shadow-bottom-dark-teal',
        { 'justify-center': justify === 'center' },
        className
      )}
    >
      <NbiLogo className="h-12" />
      {children}
    </header>
  );
};
